import axios from "axios"


export default function errorHandlerWithCallback(callbackFunc) {
  return function (error) {
    if (axios.isCancel(error)) {
      console.error('Request canceled', error.message);
    } else if (error.response?.data) {
      callbackFunc(error.response.data);
    } else if (typeof callbackFunc === 'function') {
      // Timeout, rede, CORS, respostas vazias: o callback precisa rodar para a UI
      // encerrar loading e tratar ausência de dados (ex.: /api/service/rainfall).
      console.error(error?.message || error);
      callbackFunc(null);
    }
  }
}